import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a09dc61a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titleArea" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Gradientor"),
  /*#__PURE__*/_createElementVNode("span", null, "Pick a color :")
], -1))
const _hoisted_3 = { class: "inputArea" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Or", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "btnArea" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "ABOUT" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_about = _resolveComponent("about")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("section", null, [
        _createElementVNode("label", {
          for: "COLOR",
          class: _normalizeClass({ disable: _ctx.state.input_state })
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.text) = $event)),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.colorInput($event))),
            id: "COLOR",
            autocomplete: "off"
          }, null, 544), [
            [_vModelText, _ctx.state.text]
          ])
        ], 2)
      ]),
      _createElementVNode("section", null, [
        _hoisted_4,
        _createElementVNode("label", {
          for: "COLOR_PICKER",
          ref: "COLOR_PICKER",
          style: _normalizeStyle('background:#' + _ctx.state.colorPicker)
        }, [
          _createElementVNode("input", {
            id: "COLOR_PICKER",
            type: "color",
            value: '#' + _ctx.state.colorPicker,
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.colorPickerInput($event)))
          }, null, 40, _hoisted_5)
        ], 4)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.randomAllColors && _ctx.randomAllColors(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.state.imgs.dice
        }, null, 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.showAbout = !_ctx.state.showAbout))
        }, [
          _createElementVNode("img", {
            src: _ctx.state.imgs.about
          }, null, 8, _hoisted_9)
        ]),
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_ctx.state.showAbout)
              ? (_openBlock(), _createBlock(_component_about, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}